import React from 'react'
import MapPageComponent from '../components/map-page'

const MapPage = () => {
  return <MapPageComponent />
}

export default MapPage



// WEBPACK FOOTER //
// ./src/pages/map.js